// app/en/home/components/footer.tsx
import styles from './footer.module.css';

const Footer = () => {
  return (
    <footer id="contact" className={styles.footer}>
        <div className="page-container"> {/* Using global container */}
             © 2025 PyleeAI. All Rights Reserved.
        </div>
    </footer>
  );
};

export default Footer;